import Vue from 'vue'

const INERTED = new WeakMap()

export const inert = Vue.directive('inert', function (el, binding) {
  const {value: inert} = binding
  const queue = [el]

  while (queue.length > 0) {
    const next = queue.pop()

    if (inert) {
      if (next.tabIndex >= 0) {
        const value = next.hasAttribute('tabindex')
          ? next.getAttribute('tabindex')
          : true

        INERTED.set(next, {origin: el, value})

        next.setAttribute('tabindex', -1)
      }
    } else if (INERTED.has(next)) {
      const previous = INERTED.get(next)

      if (previous.origin !== el && !el.contains(previous.origin)) {
        continue
      }

      if (previous.value === true) {
        next.removeAttribute('tabindex')
      } else {
        next.setAttribute('tabindex', previous.value)
      }

      INERTED.delete(next)
    }

    if (next.children) {
      for (let i = 0, n = next.children.length; i < n; i++) {
        queue.push(next.children[i])
      }
    }
  }
})
